import { put, call } from 'redux-saga/effects'

import { REQUEST_NOTIFICATION_CONFIG_V3, getNotificationConfig } from 'actions/V3/notificationConfig'
import { watchRequestNoCancel } from 'sagas/helper'

import { apiV3 } from 'utils/api'

function* request(args: any) {
  const { data, meta } = yield call(apiV3, '/notification_configs', 'get', {
    ...args
  })
  yield put(getNotificationConfig(args.category || 'all', data, meta, args))
  return data
}

export default watchRequestNoCancel(REQUEST_NOTIFICATION_CONFIG_V3, request)
